export const Check = () => (
  <svg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M1.6665 4.29808L3.65481 6.22791L8.33317 1.6665'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </svg>
);

export const CheckTree = () => (
  <svg width='60' height='40' viewBox='0 0 60 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='34' width='1' height='40' fill='#CBD5E1' />
    <rect width='18' height='1' transform='matrix(1 0 0 -1 34 21)' fill='#CBD5E1' />
  </svg>
);

export const CheckTreeDivided = (props) => (
  <svg
    style={{ ...props?.style }}
    width='76'
    height='40'
    viewBox='0 0 76 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='36' width='1' height='40' fill='#CBD5E1' />
    <rect width='31' height='1' transform='matrix(1 0 0 -1 37 21)' fill='#CBD5E1' />
  </svg>
);

export const CheckTreeDividedColumns = (props) => (
  <svg
    style={{ ...props?.style }}
    width='60'
    height='40'
    viewBox='0 0 60 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='34' width='1' height='40' fill='#CBD5E1' />
    <rect width='18' height='1' transform='matrix(1 0 0 -1 34 21)' fill='#CBD5E1' />
  </svg>
);

export const CheckTreeDividedShort = () => (
  <svg width='52' height='40' viewBox='0 0 52 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='11' width='1' height='40' fill='#CBD5E1' />
    <rect width='31' height='1' transform='matrix(1 0 0 -1 13 21)' fill='#CBD5E1' />
  </svg>
);

export const CheckTreeLine = () => (
  <svg width='76' height='40' viewBox='0 0 76 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='36' width='1' height='40' fill='#CBD5E1' />
  </svg>
);

export const CheckTreeExportModalManageCampaigns = () => (
  <svg width='60' height='48' viewBox='0 0 60 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='34' width='1' height='48' fill='#CBD5E1' />
    <rect width='18' height='1' transform='matrix(1 0 0 -1 34 25)' fill='#CBD5E1' />
  </svg>
);
